module.exports = __webpack_public_path__ + "static/media/fuzetea.7740eb55.jpg";